module.exports = __webpack_public_path__ + "img/3.51095dec.png";